import { render, staticRenderFns } from "./choose-group.vue?vue&type=template&id=3d928fb2&scoped=true"
import script from "./choose-group.vue?vue&type=script&lang=js"
export * from "./choose-group.vue?vue&type=script&lang=js"
import style0 from "./choose-group.vue?vue&type=style&index=0&id=3d928fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d928fb2",
  null
  
)

export default component.exports